import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Gift, BriefcaseMedical, ClipboardList, DoorOpen, ChevronDown, ChevronUp } from 'lucide-react';
import { trackAddToCart } from './utils/metaPixel';
function BonusMini({
  icon,
  title,
  desc
}: {
  icon: React.ReactNode;
  title: string;
  desc: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="bg-neutral-950 border border-neutral-800 rounded-xl p-4 text-left" data-id="element-295">
      <div className="flex items-center gap-3" data-id="element-296">
        <div className="bg-brand/10 text-brand p-2 rounded-lg shrink-0" data-id="element-297">
          {icon}
        </div>
        <div className="flex-1 min-w-0" data-id="element-298">
          <div className="flex items-center gap-2" data-id="element-299">
            <span className="text-[10px] font-bold text-brand uppercase tracking-wider bg-brand/10 px-2 py-0.5 rounded-full" data-id="element-300">
              Bono
            </span>
            <h4 className="text-white font-bold text-sm truncate" data-id="element-301">{title}</h4>
          </div>
          <AnimatePresence data-id="element-302">
            {open && <motion.p initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} className="text-neutral-400 text-xs mt-1.5 leading-relaxed overflow-hidden" data-id="element-303">
                {desc}
              </motion.p>}
          </AnimatePresence>
        </div>
        <button onClick={() => setOpen(!open)} className="text-neutral-500 hover:text-brand transition-colors shrink-0" data-id="element-304">
          {open ? <ChevronUp size={16} data-id="element-305" /> : <ChevronDown size={16} data-id="element-306" />}
        </button>
      </div>
    </div>;
}
export function PricingCTA() {
  return <section id="pricing" className="py-10 md:py-14 px-4 bg-neutral-950 relative overflow-hidden" data-id="element-307">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand/10 blur-[120px] rounded-full pointer-events-none" data-id="element-308" />

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-309">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-neutral-900 border-2 border-brand/30 rounded-2xl p-5 md:p-10 text-center shadow-[0_0_50px_rgba(255,107,0,0.1)]" data-id="element-310">
          <div className="flex justify-center mb-3" data-id="element-311">
            <div className="bg-brand/10 text-brand p-2 rounded-full" data-id="element-312">
              <ShieldCheck size={32} data-id="element-313" />
            </div>
          </div>

          <h2 className="text-2xl md:text-5xl font-display text-white mb-3" data-id="element-314">
            Protegé a tu michi por menos de lo que cuesta una bolsa de
            piedritas.
          </h2>

          <p className="text-base md:text-lg text-neutral-300 mb-4 max-w-2xl mx-auto" data-id="element-315">
            Accedé a la Guía de Primeros Auxilios Felinos y llevate todos los
            bonos de acción rápida hoy mismo.
          </p>

          {/* Mini Bonos */}
          <p className="text-sm font-bold text-brand uppercase tracking-widest mb-2" data-id="element-316">
            También te llevás estos bonos gratis
          </p>
          <div className="grid grid-cols-3 gap-2 mb-5 max-w-sm mx-auto" data-id="element-317">
            <div className="rounded-xl overflow-hidden border border-neutral-800 bg-neutral-950" data-id="element-318">
              <img src="https://cdn.magicpatterns.com/uploads/s6qAfuPWzMHLKzRnQ7pXMr/Bono_1.png" alt="Botiquín Felino Express" className="w-full h-auto object-cover" data-id="element-319" />
              <p className="text-[10px] text-neutral-400 text-center py-1.5 font-medium" data-id="element-320">
                Botiquín Express
              </p>
            </div>
            <div className="rounded-xl overflow-hidden border border-neutral-800 bg-neutral-950" data-id="element-321">
              <img src="https://cdn.magicpatterns.com/uploads/x5JFDXYyddBBk6UHhUqQAG/Bono_2.png" alt="Ficha de Emergencia" className="w-full h-auto object-cover" data-id="element-322" />
              <p className="text-[10px] text-neutral-400 text-center py-1.5 font-medium" data-id="element-323">
                Ficha Emergencia
              </p>
            </div>
            <div className="rounded-xl overflow-hidden border border-neutral-800 bg-neutral-950" data-id="element-324">
              <img src="https://cdn.magicpatterns.com/uploads/cZ7u1mFYZXmvzft4CC12eV/Bono_3.png" alt="Checklist 60 Segundos" className="w-full h-auto object-cover" data-id="element-325" />
              <p className="text-[10px] text-neutral-400 text-center py-1.5 font-medium" data-id="element-326">
                Checklist 60s
              </p>
            </div>
          </div>

          <div className="mb-4" data-id="element-327">
            <div className="text-neutral-400 text-xs md:text-sm font-medium mb-1 uppercase tracking-widest" data-id="element-328">
              Precio Especial
            </div>
            <div className="text-4xl md:text-7xl font-display text-brand drop-shadow-[0_0_15px_rgba(255,107,0,0.5)]" data-id="element-329">
              $9.499{' '}
              <span className="text-xl md:text-2xl text-neutral-500" data-id="element-330">ARS</span>
            </div>
          </div>

          <Button href="https://amigospeludosarg.shop/cart/49119681052914:1" size="xl" className="w-full md:w-auto mb-3" onClick={trackAddToCart} data-id="element-331">
            ¡QUIERO EL PROTOCOLO DE EMERGENCIA AHORA!
          </Button>

          <p className="text-neutral-500 text-xs md:text-sm font-medium" data-id="element-332">
            Recibís el acceso inmediato en tu email tras el pago.
          </p>
        </motion.div>
      </div>
    </section>;
}